import { useState, useContext } from "react";
import DestinationsContext from "../../context/DestinationsContext";
import ShowFooterLinks from "./ShowFooterLinks";
const FooterLinks = () => {
  const {
    destinationsData: { destinations },
  } = useContext(DestinationsContext);
  const [state] = useState({
    pages: [
      { id: 1, name: "home", route: "/" },
      { id: 2, name: "about", route: "/about" },
      { id: 3, name: "contact", route: "/contact" },
    ],
    social_media: [
      { id: 1, name: "facebook", route: "https://www.facebook.com/" },
      { id: 2, name: "twitter", route: "https://www.x.com/" },
      { id: 3, name: "instagram", route: "https://www.instagram.com/" },
      { id: 4, name: "tiktok", route: "https://www.tiktok.com/" },
    ],
    headings: {
      pages: "pages",
      social_media: "Our Social Media",
      services: "services",
    },
  });
  const { headings, pages, social_media } = state;
  return (
    <div className="row">
      <div className="col-4 p-15">
        <h3 className="footer__heading">{headings.pages}</h3>
        <ShowFooterLinks links={pages} />
      </div>
      <div className="col-4 p-15">
        <h3 className="footer__heading">{headings.social_media}</h3>
        <ShowFooterLinks links={social_media} external={true} />
      </div>
      <div className="col-4 p-15">
        <h3 className="footer__heading">{headings.services}</h3>
        <ShowFooterLinks links={destinations} />
      </div>
    </div>
  );
};
export default FooterLinks;
